
  import Task from '../models/Task'
  import TaskCard from './TaskCard.vue'
  import { Component, Prop, Vue } from 'vue-property-decorator'
  import {
    QBtn,
    QCard,
    QCardActions,
    QCardSection,
    QCarousel,
    QCarouselSlide,
    QChip,
    QTooltip
  } from 'quasar'

  @Component({
    components: {
      QCarouselSlide,
      QTooltip,
      QCarousel,
      QChip,
      QCardActions,
      QCard,
      QCardSection,
      QBtn,
      TaskCard
    }
  })
  export default class TaskList extends Vue {
    @Prop()
    tasks: Task[]

    @Prop({ default: false })
    loading: boolean

    @Prop()
    label: string

    @Prop()
    icon: string

    @Prop({ default: false })
    showDots: boolean

    @Prop({ default: false })
    fullPageView: boolean

    @Prop({ default: false })
    isMobile: boolean

    get textClass() {
      return this.isMobile ? 'text-blue-grey-9 text-bold' : 'text-grey-1'
    }
  }
